import React from "react";
import { createRoot } from 'react-dom/client';
import SignupApp from "./signup-app.jsx";
import { initRum } from '../utils/datadog.js';

initRum();

const container = document.getElementById("preview-root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <SignupApp />
  </React.StrictMode>
);